export default {
    getImageEvent(state) {
        return state.event_image
    },
    getRanking(state) {
        return state.ranking
    },
    getOnline(state) {
        return state.online
    },
    getIsLoading(state) {
        return state.loading
    },
    getDownloadLinks(state) {
        return state.downloadLinks
    },
    getServerInfo(state) {
        return state.serverInfo
    },
    getNewsAndUpdates(state) {
        return state.events.filter(event => {
            return event.Type === 'NewsAndUpdates'
        })
    },
    getGuides(state) {
        return state.events.filter(event => {
            return event.Type === 'Guides'
        })
    },
    getEvents(state) {
        return state.events.filter(event => {
            return event.Type === 'Events'
        })
    },
    getAllEvents(state) {
        return state.events
    },
    getDonationDetails(state) {
        return state.donation_info
    },
    getShowOnline (state) {
        return state.show_online
    }
}